import { HowDidYouObtainLecBrochureInput } from '../../lib/types/models/how-did-you-obtain-lec-brochures/how-did-you-obtain-lec-brochure-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function createHowDidYouObtainLECBrochure(data: HowDidYouObtainLecBrochureInput) {
  return restApiClient
    .url(constructApiUrl(API.howDidYouObtainLECBrochure.create.url, null))
    .post(data)
}
